"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _PackageCard = _interopRequireDefault(require("../PackageCard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function DefaultCard(_ref) {
  let {
    data,
    highlighted,
    highlightColor
  } = _ref;
  let isFeatured = false;
  if (data.categories && data.categories.length > 0) {
    const featuredPackage = data.categories.find(cat => cat.name === "featured");
    if (featuredPackage) {
      isFeatured = true;
    }
  }
  return /*#__PURE__*/_react.default.createElement(_PackageCard.default, {
    data: data,
    showIcon: true,
    showVerification: true,
    isHighlighted: isFeatured || highlighted,
    highlightColor: highlightColor
  });
}
DefaultCard.propTypes = {
  highlighted: _propTypes.default.bool,
  highlightColor: _propTypes.default.string
};
var _default = exports.default = DefaultCard;